import { Box, Typography, TextField, Accordion, AccordionSummary, AccordionDetails, FormControl, Select, MenuItem, FormControlLabel, Switch } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

export function ButtonNodeFields({ localNodeData, updateNodeData, buttons, updateButton }) {
  const AdvanceResponse = localNodeData.AdvanceResponse || false;

  return (
    <>
      <Box>
        <Accordion sx={{ mt: 2, mb: 2 }}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography variant="body2">Header (opcional)</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <FormControl fullWidth size="small" sx={{ mb: 2 }}>
              <Select
                  value={localNodeData.headerType || ''}
                  onChange={(e) => updateNodeData('headerType', e.target.value)}
                  displayEmpty
              >
                <MenuItem value="">Sin header</MenuItem>
                <MenuItem value="text">Texto</MenuItem>
                <MenuItem value="image">Imagen</MenuItem>
                <MenuItem value="video">Video</MenuItem>
                <MenuItem value="document">Documento</MenuItem>
              </Select>
            </FormControl>

            {localNodeData.headerType === 'text' && (
                <TextField
                    label="Texto del header (máx. 60 caracteres)"
                    value={localNodeData.headerText || ''}
                    size="small"
                    fullWidth
                    inputProps={{ maxLength: 60 }}
                    onChange={(e) => updateNodeData('headerText', e.target.value)}
                />
            )}

            {localNodeData.headerType === 'image' && (
                <TextField
                    label="mediaId de la imagen (Graph)"
                    value={localNodeData.mediaId || ''}
                    size="small"
                    fullWidth
                    onChange={(e) => updateNodeData('mediaId', e.target.value)}
                />
            )}

            {localNodeData.headerType === 'video' && (
                <TextField
                    label="mediaId del video (Graph)"
                    value={localNodeData.mediaId || ''}
                    size="small"
                    fullWidth
                    onChange={(e) => updateNodeData('mediaId', e.target.value)}
                />
            )}

            {localNodeData.headerType === 'document' && (
                <TextField
                    label="mediaId del documento (Graph)"
                    value={localNodeData.mediaId || ''}
                    size="small"
                    fullWidth
                    onChange={(e) => updateNodeData('mediaId', e.target.value)}
                />
            )}
          </AccordionDetails>
        </Accordion>
        <Typography variant="body2" sx={{ fontWeight: 500, mb: 1 }}>
          Contenido del Mensaje
        </Typography>
        <TextField
            value={localNodeData.bodyText || ''}
            size="small"
            fullWidth
            multiline
            minRows={3}
            // permite que el usuario cambie el alto del área de texto
            sx={{
              '& .MuiInputBase-root': {
                alignItems: 'flex-start',
              },
              '& textarea': {
                resize: 'vertical', // usuario puede agrandar/achicar verticalmente
                overflow: 'auto',
              },
            }}
            onChange={(e) => updateNodeData('bodyText', e.target.value)}
        />
      </Box>
      <Box>
        <Typography variant="body2" sx={{ fontWeight: 500, mb: 1 }}>
          Texto de subtitulo
        </Typography>
        <TextField
          value={localNodeData.footerText || ''}
          size="small"
          fullWidth
          multiline
          rows={1}
          onChange={(e) => updateNodeData('footerText', e.target.value)}
        />
      </Box>
      {/* Configuración para almacenar respuesta, igual que en ListNodeFields */}
      <Box sx={{ mt: 2 }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
          <Typography variant="body2" sx={{ fontWeight: 500 }}>
            Respuesta esperada
          </Typography>
          <FormControlLabel
            sx={{ m: 0 }}
            control={
              <Switch
                size="small"
                checked={AdvanceResponse}
                onChange={(e) => updateNodeData('AdvanceResponse', e.target.checked)}
              />
            }
            label="Almacenar respuesta"
          />
        </Box>

        {/* MODO SIMPLE: sólo descripción/ayuda opcional para la respuesta */}
        {!AdvanceResponse && (
          <TextField
            value={localNodeData.expected || ''}
            size="small"
            fullWidth
            multiline
            rows={2}
            placeholder="Describe brevemente qué esperas que el usuario responda"
            onChange={(e) => updateNodeData('expected', e.target.value)}
          />
        )}

        {/* MODO AVANZADO: separar en output_key y descripción/esperado */}
        {AdvanceResponse && (
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
            <TextField
              label="output_key"
              placeholder="Ej: opcion_boton_seleccionada"
              value={localNodeData.OutputKey || ''}
              size="small"
              fullWidth
              onChange={(e) => updateNodeData('OutputKey', e.target.value)}
            />
            <TextField
              label="Formato / valor esperado"
              placeholder="Ej: texto del botón elegido por el usuario"
              value={localNodeData.expected || ''}
              size="small"
              fullWidth
              multiline
              rows={2}
              onChange={(e) => updateNodeData('expected', e.target.value)}
            />
          </Box>
        )}
      </Box>
      {/* Header opcional, igual que en WSPUrlLinkFields pero usando mediaId en vez de URL */}
      <Box>
        <Typography variant="body2" sx={{ fontWeight: 500, mb: 1 }}>
          Opciones de Botones
        </Typography>
        {buttons.map((button, index) => (
          <Box
            key={button.id}
            sx={{
              display: 'flex',
              gap: 1,
              mb: 1,
              alignItems: 'center'
            }}
          >
            <TextField
              value={button.title}
              size="small"
              fullWidth
              placeholder={`Opción ${index + 1}`}
              onChange={(e) => updateButton(button.id, e.target.value)}
            />
          </Box>
        ))}
      </Box>
    </>
  );
}